import React, { Component, memo } from "react";
import "../css/import.css";
// import 'react-dropdown/style.css';
// import Dropdown from 'react-dropdown';
import { Grid, Row, Col } from 'react-bootstrap';
import moment from 'moment';
import 'moment-timezone';
import { ImportService } from "../Services/ImportService";
import { NotificationService } from "../Services/NotificationService";
import PapaParse from 'papaparse';
import XLSX from 'xlsx';
import { UserService } from "../Services/UserService";
import { format_export, toInt, format_without_time, currentTimeInIST, getTimeInIST, format_display_fancy_notime_withDay, format_fancy_notime } from "../Utils";
import { ProductService } from "../Services/ProductService";
import { DeliveryService } from "../Services/DeliveryService";
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { Table, TableHead, TableRow, TableCell, Typography, TableBody, Fade, CircularProgress, withStyles, FormControl, Divider, TextField, Tooltip, FormHelperText } from "@material-ui/core";
import { Grid as MatGrid}  from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CustomFullDialog from "../components/CustomFullDialog";
import { Color, LEDGER_TYPE } from "../Constants";
import { RouteService } from "../Services/RouteService";
import AutoCompleteSelection from "../components/AutoCompleteSelection_v2";
import PropTypes from 'prop-types';
import Skeleton from '@material-ui/lab/Skeleton';
import CustomDialog from "../components/CustomDialog";
import { ROLES } from "../Roles";

const styles = theme => ({
  button: {
    margin: theme.spacing(1),
  },
  formControlAutoComplete: {
    zIndex: 2,
    margin: theme.spacing(1),
    minWidth: '50vw',
    [theme.breakpoints.up('md')]: {
        marginLeft: theme.spacing(1),
    },
  },
  tableSection: {
    maxWidth: '100vw',
    overflow: 'auto',
    maxHeight: 420
  },
  cell: {
    paddingLeft: 5, 
    paddingRight: 5
  }
})

class Import extends Component {

  constructor(props) {
    super(props);
    this.state = {
      date: null,
      headers: [],
      data: [],
      // options: [],
      routeId: null,
      clean: true,
      open: false,
      missingProducts: [],
      missingProductsFiles: [],
	    payload: [],
      import_status: [],
      dialog: {
        open: false,
        showSpinner: false,
        title: undefined,
        children: [],
        selected_route: []
      },
      route_options: [],
      tomorrow: moment().add("1", "day"),
      preditEnabled: true,
      product_title_cell: [],
      store_rows: [],

      summary : {
				children: [],
				title : undefined, 
				open : false
      },
      import_minqty_status: []
    }
    // this.onFormSubmit = this.onFormSubmit.bind(this)
    // this.onChange = this.onChange.bind(this)
    // this.fileUpload = this.fileUpload.bind(this)
    this.handleUpload = this.handleUpload.bind(this);
    this.handleUploadError = this.handleUploadError.bind(this);
    // this.onRouteChange = this.onRouteChange.bind(this);
    //this.importFile = this.importFile.bind(this);
    this.handleChangeCheckBox = this.handleChangeCheckBox.bind(this);

    this.importFileMultiple = this.importFileMultiple.bind(this);
    this.fileInput = React.createRef();

    //Store Delivery
    this.downloadTemplate = this.downloadTemplate.bind(this);
    this.fileInputStore = React.createRef();
    this.importFileMultipleStore = this.importFileMultipleStore.bind(this);

    //Store Min Qty
    this.fileInputMinQty = React.createRef();

    //Google Map kml files
    this.fileInputMap = React.createRef();
    this.importFileMap = this.importFileMap.bind(this);
    this.reassign = this.reassign.bind(this);

    // Ledger
    this.filePendingMap = React.createRef();
    this.fileOverdueMap = React.createRef();
  }

  handleSummaryClose = () => {
		this.setState({summary :{open: false, children: [], title: undefined}});
	}


  handleClose = (showConfirmDialog = true) => {
    if(showConfirmDialog) {
      this.props.showConfirmDialog("Are you sure you want to cancel the scheduling?", "Confirm", () => {
        this.setState({store_rows: [], schedules: [], dialog :{open: false, showSpinner: false, children: [], title: undefined, selected_route: []}});
        this.props.closeConfirmDialog();
      })
    } else {
      this.setState({store_rows: [], schedules: [], dialog :{open: false, showSpinner: false, children: [], title: undefined, selected_route: []}});
    }
  }
  
  componentDidMount(){
    this.props.setTitle('Import');
    let classes = this.props.classes;
    this.fetchRoutes();
    ProductService.getProductList()
    .then((data) => {
        let product_title_cell = [];
        product_title_cell.push(<TableCell key={"index"} className={classes.cell}>Sl.No.</TableCell>);
        product_title_cell.push(<TableCell key={"store"} className={classes.cell}>STORE NAME</TableCell>)
        data.products.filter(p => p.status !== -1).forEach((p,i) => {
          product_title_cell.push(<TableCell key={i} className={classes.cell}>{p.name}</TableCell>);
        });
        this.setState({master_products: data.products.filter(p => p.status !== -1), product_title_cell});
    });
  }

  fetchRoutes = () => {
    RouteService.getRouteListWithMapping()
      .then((data) => {
          let route_options = data.routes.map((element) =>(
              ({key: element.id, id: element.id, value: element.id, label: element.name})
          ));
          this.setState({route_options, preditEnabled: true});
      })
      .catch((error) => {
          console.log(error);
      });
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  openDialog = event => {
		if(event){
			event.preventDefault();
    }
    
    let tomorrow = moment().add('1', 'days');

    let children = [];

    this.setState(prevState => ({tomorrow, dialog: { ...prevState.dialog, open: true, children, title: `Predict Schedules for ${getTimeInIST(tomorrow).format(format_display_fancy_notime_withDay)}`}}));
	}

  handleRouteSelection = (routes) => {
    this.setState(prevState => ({dialog: {...prevState.dialog ,selected_route : routes ? routes : []}}), () => {
    });
  }

  predict = () => {
    if(this.state.schedules && this.state.schedules.length > 0){
        this.props.showConfirmDialog('Any changes made will be lost. Do you want to continue?', 'Confirm', () => {
            this.preditConfirm();
            this.props.closeConfirmDialog();
        })
    } else {
      this.preditConfirm();
    }

  }

  preditConfirm = () => {
    let selected_route = this.state.dialog.selected_route;
    let tomorrow = this.state.tomorrow;
    let schedules = [];

    if(selected_route.length > 0){
      let store_rows = [];
      for(let i = 0; i < 5 ;i++){
        store_rows.push(<ProductRowSkeleton key={i} count={this.state.master_products.length + 2}/>);
      }
      this.setState({store_rows, showSpinner: true});
      Promise.all(selected_route.map(route => ImportService.fetchPredictions(route.id, moment(tomorrow).format(format_without_time))))
      .then(data => {
        store_rows = [];
        let slno = 0;
        data.forEach(dd => {
          dd.predictions.forEach((store, key)=> {
              let product_rows = store.store_predictions;
              let cells = [];
              this.state.master_products.forEach((p,i) => {
                let prList = product_rows.filter(pr => pr.product_id === p.id);
                let d = undefined;
                if(prList.length > 0){
                  d = prList[0];
                }
                let sch = { uid: store.store_id + p.id, store_name: store.store_name, user_id: store.store_id, product_name: p.name, product_id: p.id, already_scheduled: d.already_scheduled, product_qty: d.already_scheduled > 0 ? d.already_scheduled  : ((d.avg_delivered_count - d.avg_returned_count) > 0 ? (d.avg_delivered_count - d.avg_returned_count) : 0), avg_delivered_count: d.avg_delivered_count, last_delivered_count: d.last_delivered_count, avg_returned_count: d.avg_returned_count, last_returned_count: d.last_returned_count };
                schedules.push(sch);
                cells.push(<TableCell key={i} align="center"><ProductCell schedule={sch} color={sch.already_scheduled > 0 ? 'black' : (sch.product_qty > sch.last_delivered_count ? 'green' : (sch.product_qty < sch.last_delivered_count ? 'red' : 'blue'))} handleChange={this.handleChange} value={sch.product_qty} label={sch.store_name}/></TableCell>);
              });
              store_rows.push(
                        <TableRow key={store.store_id}>
                        <TableCell align="center">{++slno}</TableCell>
                          <TableCell component="th" scope="row" style={{minWidth: 120}}>
                            <React.Fragment>
                              <Typography variant="subtitle2">
                                {store.store_name}
                              </Typography>
                              last delivered on:<br/>
                              <Typography variant="caption" color="secondary">
                                {store.last_delivered_date ? moment(store.last_delivered_date).format(format_fancy_notime) : "Not Available"}
                              </Typography>
                            </React.Fragment>
                          </TableCell>
                          {cells}
                        </TableRow>
              );
            });
        });
        this.setState({store_rows, showSpinner: false, schedules});
      })
    }
    

    // let store_rows = [];
    

    // this.setState({store_rows});

  }

  handleChange = (uid, value) => {
    let schedules = this.state.schedules;

    let schList = schedules.filter(s => s.uid === uid);
    if(schList.length === 1){
      let sch = schList[0];
      sch.product_qty = toInt(value);
      sch.modified = true;
      this.setState({schedules});
    }
  }

  handleUpload(dataFromFile, filename) {
    console.log("Converting to JSON");
    if (dataFromFile.length && dataFromFile[0][0].includes('STORE')) {
      let day, month, year, routeId;
      let dateString = dataFromFile[0][0];
      day = dateString.substring(6, dateString.indexOf(' '));
      month = dateString.substring(dateString.indexOf(' ') + 1);
      year = dataFromFile[0][1].trim();
      this.setState({ date: new Date(day + '-' + month + '-' + year) });

      // Populate headers and data:
      let row = 1;
      for (var i = 1; i < dataFromFile.length; i++) {
        if (dataFromFile[i][0].length > 1) {
          row = i;
          break;
        }
      }
      let headers = dataFromFile[row].map(function (element) {
        element = element.replace(/\n/g, "");
        return { label: element, key: element };
      });
      this.setState({ headers: headers });

      let data = dataFromFile.slice(row + 1).map(function (element, index) {

        var kv = {};
        if (element.length > 1) {
          for (var i = 0; i < element.length; ++i) {
            if (element[i] !== '' && headers[i].key !== '$$hashKey' && headers[i].key !== 'newCompleteFlatComparator' && headers[i].key !== 'descendingFlatComparator' && headers[i].key !== 'flatComparator') {
              let key = headers[i].key;
              kv[key] = element[i].replace(/(\r\n\t|\n|\r|\r\t|\t)/gm, "");
              if (index === 0 && key === "buildingName") {
                routeId = kv[key];
              }
            }
          }
        } else {
          return null;
        }
        return kv;
      });

      console.log("Data");
      console.log(data);
      data = data.filter(d => d !== null && Object.keys(d).length !== 0);
      this.setState({ data: data, routeId: routeId });
    }

  }

  handleUploadError(error) {
    console.log(error);
  }

  parseResult = (results, file) => {
    let {clean, master_products} = this.state;
    if (results && results.errors)
    {
      if (results.errors)
      {
      }
      
    }
    let dataFromFile = results.data;
    if (dataFromFile.length && dataFromFile[0][0].includes('STORE')) {
        let day, month, year, routeId;
        let missingProducts = [];
        let dateString = dataFromFile[0][0];
        day = dateString.substring(6, dateString.indexOf(' '));
        month = dateString.substring(dateString.indexOf(' ') + 1);
        year = dataFromFile[0][1].trim();
        // this.setState({ date: new Date(day + '-' + month + '-' + year) });
        let date = new Date(day + '-' + month + '-' + year);
        // Populate headers and data:
        let row = 1;
        for (var i = 1; i < dataFromFile.length; i++) {
          if (dataFromFile[i][0].length > 1) {
            row = i;
            break;
          }
        }
        let headers = dataFromFile[row].map(function (element) {
          element = element.replace(/\n/g, "");
          return { label: element, key: element };
        });
        // this.setState({ headers: headers });
  
        let data = dataFromFile.slice(row + 1).map(function (element, index) {
  
          var kv = {};
          if (element.length > 1) {
            for (var i = 0; i < element.length; ++i) {
              if (element[i] !== '' && headers[i].key !== '$$hashKey' && headers[i].key !== 'newCompleteFlatComparator' && headers[i].key !== 'descendingFlatComparator' && headers[i].key !== 'flatComparator') {
                let key = headers[i].key;
                kv[key] = element[i].replace(/(\r\n\t|\n|\r|\r\t|\t)/gm, "");
                if (index === 0 && key === "buildingName") {
                  routeId = kv[key];
                }
                if(key === "productName"){
                  let p = master_products.filter(p => p.name === kv[key]);
                  if(p.length === 0){
                    missingProducts.push(kv[key]);
                  }
                }
              }
            }
          } else {
            return null;
          }
          return kv;
        });
        data = data.filter(d => d !== null && Object.keys(d).length !== 0);
        if(data.length > 0){
          if(!routeId || routeId.length > 0){
            routeId =  data[0].buildingName;
          }
          let body = {
            routeId: routeId,
            sch_date: moment(date).format("YYYY-MM-DD HH:mm:SS"),
            headers: headers,
            rows: data,
            clean: clean
          };
          
          this.setState(prevState => ({payload: [...prevState.payload, body], missingProducts: missingProducts.length ? [...prevState.missingProducts, missingProducts] : [...prevState.missingProducts], missingProductsFiles: missingProducts.length ?  [...prevState.missingProductsFiles, file.name] : [...prevState.missingProductsFiles]}));
          this.postImport();
        }
    }
  };

  postImport = () => {
    if(this.state.payload.length === this.fileInput.current.files.length){
        console.log(this.state.missingProductsFiles, this.state.missingProducts);
        if(this.state.missingProducts.length > 0){
          let missingProducts = [...new Set(this.state.missingProducts)];
          let message = (<span>
                          Products <b>'{missingProducts.join('\', \'')}'</b> are missing from the below files. 
                          Do you still want to continue with the import?<br/><br/>
                          
                          The records with the missing products will not be imported into the system.<br/>
                          <br/>
                          Files:<br/>
                          <b>
                          {this.state.missingProductsFiles.join('\n')}
                          </b>
                        </span>);

          this.props.showConfirmDialog(message, 'WARNING', this.proceed);
        } else {
          this.proceed();
        }
        
    }
  }

  proceed = () => {
    this.state.payload.forEach((p) => {
      ImportService.import(p)
      .then((data) => {
        this.setState({force: false});
        if ((data.success > 0 && data.error === 0) ||
          (p.rows.length === data.alreadyImported)) {
          this.props.showSnackBar(`Imported data for Route: ${p.routeId}`, 'success');
          let tomorrow = currentTimeInIST().add(1, "days").startOf('day');
          if (moment(getTimeInIST(p.sch_date)).isSame(tomorrow, "d")) {
            NotificationService.notifyAgentsAboutImport(p.routeId, getTimeInIST(p.sch_date));
          }
          console.log("Success in import");
        } else if (data.error > 0) {
          this.props.showSnackBar(`Import Summary 
                                    Total Records: ${p.rows.length} 
                                    Failed records: ${data.error} records 
                                    Already Imported: ${data.alreadyImported} records 
                                    Success records: ${data.success}`, 'error');
        }
        this.props.isLoading(false);
      })
      .catch(() => {
        this.props.showSnackBar("Something went wrong, could not Import data. Please try again.", 'error');
        this.props.isLoading(false);
      });
    });
    this.props.closeConfirmDialog();
  };

  importFileMultiple() {
    console.log(this.fileInput.current.files);
    this.setState({missingProducts : [], missingProductsFiles:[], payload: []});
    for (var i=0; i < this.fileInput.current.files.length; i++) {
      PapaParse.parse(this.fileInput.current.files[i], {
        complete: this.parseResult
      });
    }
  };

  handleChangeCheckBox(e) {
    let clean = e.target.checked;
    this.setState({ clean: clean });
  }

  downloadTemplate(e){
    if(e){
      e.preventDefault();
    }
    UserService.getTotalCount("STORE", '', '1')
    .then((d) => {
        UserService.getStoreListWithContracts(0, d.count, false, '1')
        .then((data) => {
            ProductService.getProductList()
            .then((data_p) => {
                let products = data_p.products.filter(p => p.status !== -1).map((p) => p.id);
                if(data.users){
                    let title = ["Date", "Store", "Store ID"];
                    title.push.apply(title, products);
                    let exportStoreData = [title];
                    this.props.isLoading(true);
                    let tomorrow = moment().utc().add(1, "days").startOf('day');
                    data.users.filter(u => u.status !== '0').forEach((user, index) => {
                      if(user.store_has_route_mapping){
                        console.log(format_export);
                        let storeArray = [moment(tomorrow).format(format_export), user.store_name, user.id];
                        exportStoreData.push(storeArray);
                      }
                    });
                    if(exportStoreData){
                        console.log(exportStoreData);
                        const wb = XLSX.utils.book_new();
                        const wsAll = XLSX.utils.aoa_to_sheet(exportStoreData);
                        console.log(wb);
                        XLSX.utils.book_append_sheet(wb, wsAll, 'Stores');
                        XLSX.writeFile(wb, "store_delivery.csv");
                        this.props.isLoading(false);
                    }
                }
            })
            .catch((error) =>{
                console.log("Error while fetching product list");
            });
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    })
    .catch(error => {
        console.log(error);
        this.props.isLoading(false);
    });
  }

  importFileMultipleStore() {
    if(!this.state.STORE_IMPORT_STARTED){
        this.setState({STORE_IMPORT_STARTED: true, import_status: []});
        console.log(this.fileInputStore.current.files);
        for (var i=0; i < this.fileInputStore.current.files.length; i++) {
          PapaParse.parse(this.fileInputStore.current.files[i], {
            complete: this.updateStatus
          });
        }
    }
  }

  updateStatus = (results) => {
		if (results && results.errors){
		  if (results.errors) {
		  }
		}
		let dataFromFile = results.data;
		if (dataFromFile.length) {
      this.props.showProgressDialog('Importing...');
			// Populate headers and data:
			let row = 0;
			for (var i = 0; i < dataFromFile.length; i++) {
			  if (dataFromFile[i][0].length > 1) {
				row = i;
				break;
			  }
			}
			let headers = dataFromFile[row].map(function (element) {
			  element = element.replace(/\n/g, "");
			  return { label: element, key: element };
			});
	  
			let data = dataFromFile.slice(row + 1).map(function (element, index) {
			  var kv = {products: []};
			  if (element.length > 1) {
				for (var i = 0; i < element.length; ++i) {
				  if (element[i] !== '') {
					let key = headers[i].key;
					if(key === 'Date' || key === 'Store' || key === 'Store ID'){
					  kv[key] = element[i].replace(/(\r\n\t|\n|\r|\r\t|\t)/gm, "");
					} else {
					  let v = element[i].replace(/(\r\n\t|\n|\r|\r\t|\t)/gm, "");
					  if(v.length > 0 && toInt(v) && toInt(v) > 0){
						kv.products.push({'product_id' : key, 'qty' : toInt(v)});
					  }
					}
					
				  }
				}
			  } else {
				return null;
			  }
			  return kv;
			});

			data = data.filter(d => d !== null && Object.keys(d).length !== 0 && d.products.length > 0);

			let rows = [];
			if(data.length > 0){
            data.forEach((d, index) => {

                d.products.forEach((p) => {
                rows.push({
                  user_id : d['Store ID'],
                  product_id : p.product_id,
                  schedule_date : moment(d['Date'], format_export).format(format_without_time) ,
                  product_qty : toInt(p.qty)
                });
                });
            });
            let body = { rows: rows, src : 'Import' };
            let import_status = [];
            DeliveryService.createDelivery(body, {'user-id' : this.props.user.id, 'user-name': this.props.user.name })
            .then((data1) => {
              console.log(data1)
              for (const [key, value] of Object.entries(data1.report)) {
                import_status.push(
                  <TableRow key={key}>
                    <TableCell>
                      <Typography variant="subtitle2">{data.filter(d => d['Store ID'] === key)[0].Store}</Typography> 
                    </TableCell>
                    <TableCell>
                      <Typography variant="subtitle1">{value.success}</Typography> 
                    </TableCell>
                    <TableCell>
                      <Typography variant="subtitle1">{value.error}</Typography> 
                    </TableCell>
                  </TableRow>
                );
              }
            this.setState({import_status});
            this.props.showSnackBar("Imported Store Deliveries", 'success');
            this.props.closeProgressDialog();
          })
          .catch((error) => {
            console.log(error);
            this.props.closeProgressDialog();
          });
			}
		}
  } 

  showSummary = () => {
    let {schedules} = this.state;
    let children = [];
    let stores = new Set(schedules.filter(s => (s.already_scheduled > 0 && s.modified) ||  (s.already_scheduled === 0 && s.product_qty > 0)).map(s => s.user_id));
    if(stores.size > 0){
        stores.forEach((store, index) => {
           
                children.push(
                  <tr key={store+"spacer"}>
                    <td colSpan={2}><Divider/></td>
                  </tr>);
            
            children.push(
                <tr key={store}>
                  <th>{schedules.filter(s => s.user_id === store && s.product_qty > 0)[0].store_name}</th>
                  <th>Units</th>
                </tr>
            );
            children = children.concat(schedules.filter(s => s.user_id === store &&  s.product_qty > 0).map((s) => (
                <tr key={store + s.product_name} style={(s.already_scheduled > 0 && s.modified) ||  (s.already_scheduled === 0 && s.product_qty > 0)? { backgroundColor: 'rgba(229,115,115 ,1)', color: 'white'} : {}}>
                  <td>{s.product_name}</td>
                  <td>{s.product_qty}</td>
                </tr>
            )));
        });
        this.setState({summary :{open: true, children, title: "Summary"}});
    } else {
      this.props.showSnackBar("No changes made.", 'warning');
    }
  }

  scheduleDeliveries = () => {
    let {schedules, tomorrow} = this.state;
    if(schedules.length > 0){
      this.props.showConfirmDialog('Schedule deliveries?', 'Confirm', () => {
        if(!this.state.dialog.showSpinner){
            this.props.closeConfirmDialog();
            this.handleSummaryClose();
            this.setState(prevState => ({ dialog: { ...prevState.dialog, showSpinner: true}}));
            let data = schedules.filter(s => (s.already_scheduled > 0 && s.modified) ||  (s.already_scheduled === 0 && s.product_qty > 0)).map(s => ({
              user_id : s.user_id,
              product_id : s.product_id,
              schedule_date : moment(tomorrow).format(format_without_time) ,
              product_qty : s.product_qty
            }));
            let body = { rows: data, src : 'Prediction API'};
            DeliveryService.createDelivery(body, {'user-id' : this.props.user.id, 'user-name': this.props.user.name })
            .then((data1) => {
              this.handleClose(false);
              this.props.showSnackBar("Scheduled store deliveries", 'success');
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    }
  }

  importFileMap() {
    console.log(this.fileInputMap.current.files);
    let files = this.fileInputMap.current.files;
    if(files.length === 1){
      let reader = new FileReader();
      reader.readAsDataURL(files[0]);
      let name = files[0].name;
      reader.onload = (e) => {
        console.log(e.target.result);
        ImportService.importMap({name: name, file: e.target.result})
        .then((data) => {
          if(data.success){
            this.props.showSnackBar("Imported file", 'success');
            this.reassign();
            
          }
        })
        .catch((error) => {
          this.props.showSnackBar("File import failed. Please try again. Check Extension and file name.", 'error');
          console.log(error);
        });
      }
    }
  }

  importPendingReport = (type) => e =>  {
    this.setState({ledger_output_overdue: undefined, ledger_output_pending: undefined});
    console.log((type === LEDGER_TYPE.PENDING) ? this.filePendingMap.current.files: this.fileOverdueMap.current.files);
    let files = (type === LEDGER_TYPE.PENDING) ? this.filePendingMap.current.files: this.fileOverdueMap.current.files;
    if(files.length === 1){
      this.props.showProgressDialog('Importing...');
      let reader = new FileReader();
      reader.readAsBinaryString(files[0]);
      reader.onload = (e) => {
        // console.log(e.target.result);
        let readedData = XLSX.read(e.target.result, {type: 'binary'});
        const wsname = readedData.SheetNames[0];
        const ws = readedData.Sheets[wsname];
        const dataParse = XLSX.utils.sheet_to_json(ws, {header:1});
        
        let uploadList = [];

        dataParse.forEach((store) => {
            if(typeof store[1] == "number" && store[0] !== 'Grand Total'){
              uploadList.push({store_name: store[0], amount: store[1]});
            }
        });
        console.log(uploadList);
        ImportService.importLedger(type, {}, {rows: uploadList})
        .then((data) => {
          console.log(data);
          if(data.success === uploadList.length){
            this.props.showSnackBar("Imported Pending Ledger", 'success');
          } else {
            let op = data.mismatch_stores.map((s,i) => <p key={i}>{i+ 1}. {s}</p>);
            if(type === LEDGER_TYPE.PENDING){
              this.setState({ledger_output_pending: op});
            } else {
              this.setState({ledger_output_overdue: op});
            }
          }
          this.props.closeProgressDialog();
        })
        .catch((error) => {
          this.props.showSnackBar("File import failed. Please try again. Check Extension and file name.", 'error');
          console.log(error);
          this.props.closeProgressDialog();
        });
      }
    }
  }

  proceedWithReassignment = () => {
    this.props.closeConfirmDialog();
    ImportService.reassignRoutes({})
    .then((data) => {
        console.log(data);
        if( data.total > 0 ){
          if(data.conflicts === 0 && data.changed > 0){
            this.props.showSnackBar('Reassigned Successfully.', 'success');
          } else if (data.conflicts === 0 && data.changed === 0){
            this.props.showSnackBar('No Reassignment required.', 'success');
          } else {
            this.props.showSnackBar('There are conflicts in Assigning Routes. Please resolve the conflicts manually.', 'error');
          }
        }
    })
    .catch(error => {
      this.props.showSnackBar('Something went wrong. Please try again later.', 'error');
        console.log(error);
    });
  }

  reassign(){
    this.props.showConfirmDialog(`Do you want to resign routes for Customers as per new mapping?`, undefined, this.proceedWithReassignment);
  }

  // Store Min Qty
  downloadMinQtyTemplate = (e) => {
    this.props.isLoading(true);
    UserService.getStoreListWithContracts(0, 999999, true, '1')
    .then((data) => {
        console.log(data);
        console.log(this.state.master_products);
        let products = this.state.master_products.map((p) => p.name);
        if(data.users){
            let title = ["Sl.no", "ID(DO NOT ERASE THIS COLUMN)","Store"];
            let secondRow = ['', '', ''];
            products.forEach(product => {
              title.push(product, '');
              secondRow.push('commission', 'min_qty');
            });
            let exportStoreData = [title, secondRow];
            data.users.filter(user => user.status === "1").forEach((user, index) => {
                let storeArray = [index + 1, user.id, user.store_name];
                
                let contract_row = [];
                this.state.master_products.forEach((p) =>  {
                    let cont = user.contracts.filter((c) => c.product_id === p.id);  
                    if(cont.length > 0){
                      contract_row.push(parseFloat(cont[0].commission), toInt(cont[0].min_qty));
                    } else {
                      contract_row.push(null, null);
                    }
                });
                storeArray.push.apply(storeArray, contract_row);
                exportStoreData.push(storeArray);
            });
            if(exportStoreData){
                const wb = XLSX.utils.book_new();
                const wsAll = XLSX.utils.aoa_to_sheet(exportStoreData);
                XLSX.utils.book_append_sheet(wb, wsAll, 'Stores - contract');
                XLSX.writeFile(wb, "Store List.csv");
            }
        }
        this.props.isLoading(false);
    })
    .catch(error => {
        console.log(error);
        this.props.isLoading(false);
    });
  }

  importStoreContract = () => {
    if(!this.state.STORE_MINQTY_IMPORT_STARTED){
      this.setState({STORE_MINQTY_IMPORT_STARTED: true, import_minqty_status: []});
      console.log(this.fileInputMinQty.current.files);
      let files = this.fileInputMinQty.current.files;
      if(files.length === 1){
        PapaParse.parse(files[0], {
          complete: this.updateStoreContract
        });
      }
    }
  }

  updateStoreContract = (results) => {
    this.props.showProgressDialog('Importing...');
    this.props.isLoading(true);
		if (results && results.errors){
		  if (results.errors) {
		  }
		}
		let dataFromFile = results.data;
		if (dataFromFile.length) {
      
			// Populate headers and data:
			let row = 0;
			for (var i = 0; i < dataFromFile.length; i++) {
			  if (dataFromFile[i][0].length > 1) {
				row = i;
				break;
			  }
			}
			let headers = dataFromFile[row].map(function (element) {
			  element = element.replace(/\n/g, "");
			  return element ? { label: element, key: element } : null;
      }).filter(header => header !== null);
     
      let master_products = this.state.master_products;
			let data = dataFromFile.slice(row + 2).map(function (element) {
        var kv = {products: []};
			  if (element.length > 1) {
          for (var i = 0, j = 0 ; i < headers.length; ++i, j =((i < 4) ? j + 1 : j + 2)) {
            let key = headers[i].key;
            if(key && key === 'ID(DO NOT ERASE THIS COLUMN)') {
              kv["id"] = element[i].replace(/(\r\n\t|\n|\r|\r\t|\t)/gm, "");
            } else if(key && (key === 'Sl.no' || key === 'Store')){
              kv[key] = element[i].replace(/(\r\n\t|\n|\r|\r\t|\t)/gm, "");
            } else {
              let commission = element[j].replace(/(\r\n\t|\n|\r|\r\t|\t)/gm, "");
              let min_qty = element[j+1].replace(/(\r\n\t|\n|\r|\r\t|\t)/gm, "");
              if(commission.length > 0 && parseFloat(commission)){
                let pList = master_products.filter((p) => p.name === key);
                if(pList.length === 1){
                  let product_id = pList[0].id;
                  min_qty = (min_qty.length > 0 && toInt(min_qty) && toInt(min_qty) > 0) ? toInt(min_qty) : 0;
                  kv.products.push({'product_id' : product_id, commission: (parseFloat(commission) < 0 ? -1: parseFloat(commission)), min_qty : min_qty});
                }
              }
            }
          }
			  } else {
				  return null;
			  }
			  return kv;
			});

      data = data.filter(d => d !== null && Object.keys(d).length !== 0 && d.products.length > 0);
			if(data.length > 0){
        
        let body = { rows: data};
        let import_minqty_status = [];
        UserService.updateStoreContract({'user-id' : this.props.user.id, 'user-name': this.props.user.name }, body)
        .then((data1) => {
          console.log(data1)
          data1.result.forEach((element, index) => {
            import_minqty_status.push(
              <TableRow key={index} style={{padding: 3}}>
                <TableCell  style={{paddingLeft: 3}}>
                  <Typography variant="subtitle2">{index + 1}</Typography> 
                </TableCell>
                <TableCell>
                  <Typography variant="subtitle2">{data.filter(d => d.id === element.store_id)[0].Store}</Typography> 
                </TableCell>
                <TableCell>
                  <Typography variant="subtitle1" color="secondary">{element.REMOVED}</Typography> 
                </TableCell>
                <TableCell>
                  <Typography variant="subtitle1" color="primary">{element.UPDATED}</Typography> 
                </TableCell>
              </TableRow>
            );
          });
          this.setState({import_minqty_status, STORE_MINQTY_IMPORT_STARTED: false});
          this.props.showSnackBar("Imported Store Minimum Quantities", 'success');
          this.props.isLoading(false);
          this.props.closeProgressDialog();
        })
        .catch((error) => {
          console.log(error);
          this.props.isLoading(false);
          this.props.closeProgressDialog();
        });
			}
		}
  } 

  render() {
    // const options = this.state.options;
    // const defaultOption = this.state.routeId;
    let { dialog, summary, preditEnabled, showSpinner, route_options, product_title_cell, store_rows } = this.state;
    let classes = this.props.classes;
    return (
      <div className="Home" style={{marginTop: 32}}>
        <div>

          {/* <form onSubmit={this.onFormSubmit}>
              <h3 style={{marginBottom: '20px'}}>Select DailyNinja File to upload</h3>
              <input type="file" onChange={this.onChange} style={{marginBottom: '20px'}}/>
              <Button type="submit" className="btn-danger">Upload</Button>
            </form> */}

            <div className="">
              {/* <Well style={{ maxWidth: "100%" }}>
                <Dropdown options={options} onChange={this.onRouteChange} value={defaultOption} placeholder="Select a route" /> */}
                {/* value={defaultOption} */}
                {/* <CSVReader
                  cssClass="react-csv-input"
                  onChange={this.handleUpload}
                  onFileLoaded={this.handleUpload}
                  onError={this.handleUploadError}
                  inputId="file"
                /> */}
                {/* {' '}&nbsp;
                    <Button onClick={this.importFile}>Import</Button>
              </Well> */}
              {/* <Well style={{ maxWidth: "100%", textAlign: "center", paddingLeft:"40px"}}> */}
              { this.props.modules_enabled.b2c_module &&
                <Paper style={{width: "100%", marginTop: "10pt", paddingTop : '15px', paddingLeft: "5px", paddingRight: "5px", paddingBottom: 16}}>
                  <Grid>
                    <Row>
                      <Col xs={6} md={4}>
                          <h4>Select DailyNinja File to upload</h4>
                      </Col>
                      <Col xs={6} md={4}>
                          <input type="file" id="files" name="files" accept=".csv" ref={this.fileInput} multiple/>
                          <FormControlLabel
                            style={{textAlign:"left", marginLeft: "-185px"}}
                            control={
                              <Checkbox
                                    checked={this.state.clean}
                                    onChange={this.handleChangeCheckBox}
                                    name="clean"
                                    color="primary"
                                    />
                                }
                            label="Clean previous imports"
                            />
                      </Col>
                      <Col xs={4} md={2}>
                          <Button  variant="outlined" size="medium"  style={{ marginLeft: '30px'}} color="primary" onClick={this.importFileMultiple}>IMPORT</Button>
                      </Col>
                    </Row>
                  </Grid>
                {/* </Well> */}
                </Paper>
              }
              { (this.props.user.roles.includes(ROLES.ADMIN) || this.props.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.props.user.roles.includes(ROLES.ACCOUNTS) || this.props.user.roles.includes(ROLES.ACCOUNTS_ADMIN)) && this.props.modules_enabled.b2b_module &&
                <Paper style={{width: "100%", marginTop: "10pt", paddingTop : '15px', paddingLeft: "5px", paddingRight: "5px", paddingBottom: 16}}>
                  <MatGrid container>
                    <MatGrid item xs={12} lg={12}>
                      <Typography variant="h6" style={{paddingLeft: 20, textAlign: 'left', paddingBottom: 10}}>Store</Typography>
                    </MatGrid>
                    { 
                      (this.props.user.roles.includes(ROLES.ADMIN) || this.props.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.props.user.roles.includes(ROLES.ACCOUNTS) || this.props.user.roles.includes(ROLES.ACCOUNTS_ADMIN)) &&
                        <MatGrid container item xs={12}>
                          <MatGrid item xs={12} lg={4} style={{textAlign: 'left', paddingLeft: 20}}>
                            <Typography variant="overline" style={{fontSize: 14}}>Upload Deliveries</Typography>
                          </MatGrid>
                          <MatGrid item xs={12} lg={2} style={{marginTop: 8, paddingLeft: 20}}>
                            <input type="file" id="files" name="files" accept=".csv" ref={this.fileInputStore} multiple/>
                          </MatGrid>
                          <MatGrid item xs={4} lg={4}>
                            <Button disabled={this.fileInputStore.current && this.fileInputStore.current.files.length === 0} variant="contained"  style={{ marginLeft: '30px', marginBottom: '15px'}} color="primary" onClick={this.importFileMultipleStore}>IMPORT</Button>
                          </MatGrid>
                          <MatGrid item xs={8} lg={2}>
                            { !preditEnabled &&
                                <Button disabled={preditEnabled} variant="contained" style={{width: '200px', marginBottom: '15px'}} size="medium" color="primary" onClick={this.openDialog}>Predit and schedule Deliveries for Tomorrow</Button>
                            }
                            <Button variant="outlined" style={{width: '200px', marginBottom: '15px'}} size="medium" color="primary" onClick={this.downloadTemplate}>Download template</Button>
                          </MatGrid>
                        </MatGrid>
                    }
                    { 
                      (this.props.user.roles.includes(ROLES.ADMIN) || this.props.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.props.user.roles.includes(ROLES.ACCOUNTS) || this.props.user.roles.includes(ROLES.ACCOUNTS_ADMIN)) && this.state.STORE_IMPORT_STARTED &&
                      <MatGrid item xs={12}>
                        <Table style={{minHeight: 100}}>
                          <TableHead style={{backgroundColor: '#2196f3'}}>
                            <TableRow>
                              <TableCell>
                                <Typography variant="subtitle1" style={{color: 'white'}}>Store</Typography> 
                              </TableCell>
                              <TableCell>
                                <Typography variant="subtitle1" style={{color: 'white'}}>Success</Typography> 
                              </TableCell>
                              <TableCell>
                                <Typography variant="subtitle1" style={{color: 'white'}}>Failure</Typography> 
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {this.state.import_status}
                          </TableBody>
                        </Table>
                      </MatGrid>

                    }
                    { 
                      (this.props.user.roles.includes(ROLES.ADMIN) || this.props.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.props.user.roles.includes(ROLES.ACCOUNTS) || this.props.user.roles.includes(ROLES.ACCOUNTS_ADMIN)) && this.state.STORE_IMPORT_STARTED &&
                      <MatGrid item xs={12}>
                        <Fade
                          in={this.state.STORE_IMPORT_STARTED && this.state.import_status.length === 0}
                          style={{
                            transitionDelay: this.state.STORE_IMPORT_STARTED && this.state.import_status.length === 0 ? '10ms' : '0ms',
                            zIndex: 1
                          }}
                          unmountOnExit
                          >
                          <CircularProgress />
                        </Fade>
                      </MatGrid>
                    }
                    <MatGrid item xs={12}>
                        <Divider variant="middle"/>
                    </MatGrid>
                    {
                      (this.props.user.roles.includes(ROLES.ADMIN) || this.props.user.roles.includes(ROLES.ACCOUNTS_ADMIN)) && 
                        <MatGrid container item xs={12} style={{marginTop: 16}}>
                          <MatGrid item xs={12} lg={4}  style={{textAlign: 'left', paddingLeft: 20}}>
                            <Typography variant="overline" style={{fontSize: 14}}>Update Store Contracts</Typography>
                          </MatGrid>
                          <MatGrid item xs={12} lg={2} style={{marginTop: 8, paddingLeft: 20}}>
                            <input type="file" id="files" name="files" accept=".csv" ref={this.fileInputMinQty} multiple/>
                          </MatGrid>
                          <MatGrid item xs={4} lg={4}>
                            <Button disabled={this.fileInputMinQty.current && this.fileInputMinQty.current.files.length === 0} variant="contained"  style={{ marginLeft: '30px', marginBottom: '15px'}} color="primary" onClick={this.importStoreContract}>IMPORT</Button>
                            <FormHelperText>To Remove commission please fill the field in CSV with <b>-1</b> as value</FormHelperText>
                          </MatGrid>
                          <MatGrid item xs={8} lg={2}>
                            <Button variant="outlined" style={{width: '200px', marginBottom: '15px'}} size="medium" color="primary" onClick={this.downloadMinQtyTemplate}>Download template</Button>
                          </MatGrid>
                        </MatGrid>
                    }
                    {
                      (this.props.user.roles.includes(ROLES.ADMIN) || this.props.user.roles.includes(ROLES.ACCOUNTS_ADMIN)) && 
                        this.state.import_minqty_status.length > 0 &&
                        <MatGrid item xs={12} style={{maxHeight: 300, overflow: 'auto', padding: 8}}>
                          <Table size="small" padding="none">
                            <TableHead style={{backgroundColor: '#2196f3', padding: 3}}>
                              <TableRow>
                                <TableCell>
                                </TableCell>
                                <TableCell>
                                  <Typography variant="subtitle1" style={{color: 'white'}}>Store</Typography> 
                                </TableCell>
                                <TableCell>
                                  <Typography variant="subtitle1" style={{color: 'white'}}>Removed</Typography> 
                                </TableCell>
                                <TableCell>
                                  <Typography variant="subtitle1" style={{color: 'white'}}>Updated</Typography> 
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody >
                              {this.state.import_minqty_status}
                            </TableBody>
                          </Table>
                        </MatGrid>
                    }
                  </MatGrid>
                </Paper>
              }
              { (this.props.user.roles.includes(ROLES.ADMIN) || this.props.user.roles.includes(ROLES.ACCOUNTS) || this.props.user.roles.includes(ROLES.ACCOUNTS_ADMIN)) && this.props.modules_enabled.b2b_module &&
                <Paper style={{width: "100%", marginTop: "10pt", paddingTop : '15px', paddingLeft: "5px", paddingRight: "5px", paddingBottom: 16}}>
                  <MatGrid container>
                    <MatGrid item xs={12} lg={12}>
                      <Typography variant="h6" style={{paddingLeft: 20, textAlign: 'left', paddingBottom: 10}}>Store Ledger</Typography>
                    </MatGrid>
                    <MatGrid container item xs={12}>
                      <MatGrid item xs={12} lg={4} style={{textAlign: 'left', paddingLeft: 20}}>
                        <Typography variant="overline" style={{fontSize: 14}}>Upload Pending Ledger</Typography>
                      </MatGrid>
                      <MatGrid item xs={12} lg={2} style={{marginTop: 8, paddingLeft: 20}}>
                        <input type="file" name="pending_report" accept=".xlsx" ref={this.filePendingMap}/>
                      </MatGrid>
                      <MatGrid item xs={4} lg={4}>
                        <Button disabled={false && this.filePendingMap.current && this.filePendingMap.current.files.length === 0} variant="contained" style={{ marginLeft: '30px', marginBottom: '15px'}} color="primary" onClick={this.importPendingReport(LEDGER_TYPE.PENDING)}>UPLOAD</Button>
                      </MatGrid>
                      <MatGrid item xs={8} lg={2}>
                      </MatGrid>
                    </MatGrid>
                    { this.state.ledger_output_pending && 
                      <MatGrid item xs={12}>
                        <div style={{marginLeft: 8}}>
                          <Typography variant="h6" color="secondary">Stores not found</Typography>
                        </div>
                        <div style={{maxHeight: 200, overflow: 'auto', padding: 8, border: "1px black solid"}}>
                          {this.state.ledger_output_pending}
                        </div>
                      </MatGrid>
                    }
                    <MatGrid item xs={12}>
                        <Divider variant="middle"/>
                    </MatGrid>
                    <MatGrid container item xs={12} style={{marginTop: 16}}>
                      <MatGrid item xs={12} lg={4}  style={{textAlign: 'left', paddingLeft: 20}}>
                        <Typography variant="overline" style={{fontSize: 14}}>Upload Overdue Ledger</Typography>
                      </MatGrid>
                      <MatGrid item xs={12} lg={2} style={{marginTop: 8, paddingLeft: 20}}>
                        <input type="file" name="route_mapping_file" accept=".xlsx" ref={this.fileOverdueMap}/>
                      </MatGrid>
                      <MatGrid item xs={4} lg={4}>
                        <Button disabled={false && this.fileOverdueMap.current && this.fileOverdueMap.current.files.length === 0} variant="contained"  style={{ marginLeft: '30px', marginBottom: '15px'}} color="primary" onClick={this.importPendingReport(LEDGER_TYPE.OVERDUE)}>UPLOAD</Button>
                      </MatGrid>
                      <MatGrid item xs={8} lg={2}>
                      </MatGrid>
                    </MatGrid>
                    { this.state.ledger_output_overdue && 
                      <MatGrid item xs={12} style={{maxHeight: 300, overflow: 'auto', padding: 8}}>
                        <div style={{marginLeft: 8}}>
                          <Typography variant="h6" color="secondary">Stores not found</Typography>
                        </div>
                        <div style={{maxHeight: 200, overflow: 'auto', padding: 8, border: "1px black solid"}}>
                          {this.state.ledger_output_overdue}
                        </div>
                      </MatGrid>
                    }
                  </MatGrid>
                </Paper>
              }
              { this.props.modules_enabled.customer_app_options && 
                <Paper style={{width: "100%", marginTop: "10pt", paddingTop : '15px', paddingLeft: "5px", paddingRight: "5px", paddingBottom: 16}}>
                  <Grid>
                    <Row>
                      <Col xs={6} md={4}>
                          <h4>Upload Route Map / Delivery Area file</h4>
                          <h5>(file name: delivery_area.kml / route_mapping.kml)</h5>
                      </Col>
                      <Col xs={6} md={4}>
                          <input type="file" name="route_mapping_file" accept=".kml" ref={this.fileInputMap}/>
                      </Col>
                      <Col xs={4} md={2}>
                          <Button  variant="contained" style={{width: '200px', marginBottom: '15px'}}  color="primary" onClick={this.reassign}>Reassign Routes</Button>
                          <Button  variant="outlined" style={{ marginLeft: '30px'}} color="primary" onClick={this.importFileMap}>UPLOAD</Button>
                      </Col>
                    </Row>
                  </Grid>
                </Paper>
              }
              <CustomFullDialog title={dialog.title} buttonText={"CLOSE"} handleClose={(e) => this.handleClose(true)} open={dialog.open}>
                <Fade
                  key="spinner"
                  in={showSpinner}
                  style={{
                    transitionDelay: showSpinner ? '10ms' : '0ms',
                    position: 'absolute', left: '50%', top: '50%'

                  }}
                  unmountOnExit
                  >
                  <CircularProgress style={{marginTop: 20, color: Color.green}} color="inherit" size={60}/>
                </Fade>
                <Paper style={{margin: 10, background: '#fff', minHeight: 690, paddingBottom: 16}}>
                  <div key="main-content" style={{padding: 10}}>
                    <MatGrid container spacing={1}>
                      <MatGrid item xs={2}>
                        <Typography variant="body2" component="div">
                          The Grids are colored in the following format:
                        </Typography>
                      </MatGrid> 
                      <MatGrid item xs={6}>
                        <Typography variant="body2" component="div">
                          <ul>
                            <li>Green: If the prediction is more than last delivery</li>
                            <li>Red: If the prediction is less than last delivery</li>
                            <li>Blue: If the prediction is same as last delivery or if there isn't sufficent data to predict</li>
                            <li>Black: Already Scheduled</li>
                          </ul>
                        </Typography>
                      </MatGrid>
                    </MatGrid>
                    <FormControl variant="outlined" className={classes.formControlAutoComplete}>
                      <AutoCompleteSelection
                        placeHolder="Select Routes"
                        onChange={this.handleRouteSelection}
                        name="routes"
                        isMulti={true}
                        style={{zIndex: 9999}}
                        value={dialog.selected_route}
                        options={route_options}/>
                    </FormControl>
                    <Button disabled={dialog.selected_route.length === 0 || showSpinner} variant="contained" color="primary" className={this.props.classes.button} onClick={this.predict}>
                      PREDICT
                    </Button>
                    <Divider/>
                  </div>
                  { store_rows.length > 0 && 
                    <div>
                      <div className={classes.tableSection}>
                        <Table size={"small"} stickyHeader padding={"none"}>
                          <TableHead>
                            <TableRow>
                              {product_title_cell}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {store_rows}
                          </TableBody>
                        </Table>
                        {dialog.children}
                      </div>
                      <Divider/>
                      <div key="main-buttons" style={{textAlign: 'end', marginRight: '5vw'}}>
                          <Button variant="outlined" color="secondary" className={this.props.classes.button} onClick={(e) => this.handleClose(true)}>
                            CANCEL
                          </Button> 
                          <Button variant="text" color="primary" className={this.props.classes.button} disabled={store_rows.length === 0} onClick={this.showSummary}>
                            SCHEDULE
                          </Button>
                      </div>
                    </div>
                  }
                </Paper>
              </CustomFullDialog>
              <CustomDialog fullWidth maxWidth="md" title={summary.title} buttonText={"CLOSE"} handleClose={this.handleSummaryClose} open={summary.open} buttons={<Button variant="text" color="primary" className={this.props.classes.button} disabled={store_rows.length === 0 || showSpinner} onClick={this.scheduleDeliveries}>
                  SCHEDULE
                </Button>}>
                <Table>
                  <TableBody>
                    {summary.children}
                  </TableBody>
                </Table>
              </CustomDialog>
            </div>

        </div>
      </div>
    );
  }
}

const useStyles = makeStyles(theme => ({ 
  notchedOutline: {
    borderRadius: 0
  },
  focused: {
    "& $notchedOutline": {
      borderRadius: 0
    }
  },
  black: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    backgroundColor: 'rgba(189,189,189 ,1)',
    border: '2px solid black',
    overflow: 'hidden',
    borderRadius: 4,
    width: 80
  },
  blue: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    backgroundColor: '#fcfcfb',
    border: '2px solid blue',
    overflow: 'hidden',
    borderRadius: 4,
    width: 80
  },
  red: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    backgroundColor: '#fcfcfb',
    border: '2px solid red',
    overflow: 'hidden',
    borderRadius: 4,
    width: 80
  },
  green: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    backgroundColor: '#fcfcfb',
    border: '2px solid green',
    overflow: 'hidden',
    borderRadius: 4,
    width: 80
  }
}));

ProductCell1.propTypes = {
  label: PropTypes.string,
  value: PropTypes.number,
  color: PropTypes.oneOf(['red', 'green', 'blue', 'black']),
  handleChange: PropTypes.func.isRequired
}

function ProductCell1(props) {

  const classes = useStyles();

  let {value, color, handleChange, schedule} = props;

  let colorClass = undefined;
  let tooltipMessage = 
            <React.Fragment>
              {schedule.already_scheduled > 0 && `Already Scheduled: ${schedule.already_scheduled }`}
              {schedule.already_scheduled > 0 && <br/>}
              Previous Delivery: {schedule.last_delivered_count}<br/>Avg Delivery: {schedule.avg_delivered_count}<br/>Avg Return count: {schedule.avg_returned_count}
            </React.Fragment>;
  switch(color){
    case 'red':  colorClass = classes.red;break;
    case 'green':  colorClass = classes.green; break;
    case 'blue':  colorClass = classes.blue; break;
    case 'black':  colorClass = classes.black; break;
    default: colorClass = classes.blue;break;
  }

  const handleChangeField = event => {
    handleChange(schedule.uid, event.target.value);
  };

  const LightTooltip = withStyles(theme => ({
    tooltip: {
      boxShadow: theme.shadows[1],
      fontSize: 16,
    },
  }))(Tooltip);

  return (
    <LightTooltip title={tooltipMessage}>
      <TextField
        id="outlined-number"
        defaultValue={value}
        onChange={handleChangeField}
        type="number"
        className={colorClass}
        InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            }
          ,
          inputProps:{
              min: 0,
              maxLength : 4
            }
          }}
        InputLabelProps={{
          shrink: true,
        }}
        margin="normal"
        variant="outlined"
      />
    </LightTooltip>
  );
}

function ProductRowSkeleton(props) {
  let cells = [];
  for(let i =0;i < props.count; i++){
    cells.push(
      <TableCell key={i} align="center">
        <Skeleton variant="rect" width={80} height={70} style={{margin: 3}}/>
      </TableCell>
    );
  }
  return (
    <TableRow>
      {cells}
    </TableRow>
  );

}

export const ProductCell = memo(ProductCell1);

export default withStyles(styles)(Import);